import axios from 'axios';
import { getAuthHeaders } from '../utils/authUtils';

const api = () => process.env.REACT_APP_API_URL || '';
const base = () => `${api()}/api/v3/task-views`;

const params = (filter) => {
    const out = {};
    Object.entries(filter).forEach(([k, v]) => {
        if (v !== undefined && v !== null && v !== '') {
            out[k] = v;
        }
    });
    return out;
};

/** Task lists and reports. Each view is a query over tasks with optional grouping. */
const TaskViewService = {
    /** @returns {{ views: Array<{viewKey, displayName, section, schema, calendar, calendarOn}>, landing: string }} */
    listViews: async () => (await axios.get(base(), { headers: getAuthHeaders() })).data,

    /** @returns {{ rows, groups, total, page, size, groupBy }} */
    getView: async (viewKey, filter = {}) =>
        (await axios.get(`${base()}/${viewKey}`, { headers: getAuthHeaders(), params: params(filter) })).data,

    /** The view's tasks placed on dates from..to (ISO dates), by on = 'posting' or 'due'. */
    getCalendar: async (viewKey, filter, { on, from, to }) =>
        (await axios.get(`${base()}/${viewKey}/calendar`, { headers: getAuthHeaders(), params: params({ ...filter, on, from, to }) })).data,

    /** Done posts with no date: { count, posts: [{ contentType, contentId, title, platform, categoryKey, languages, taskId }] }. */
    getPostBank: async (filter) =>
        (await axios.get(`${base()}/posting-calendar/bank`, { headers: getAuthHeaders(), params: params(filter) })).data,

    /** What the Filters panel offers: { languages: [{key, label}], stages: [{key, label}], assignees, pms }. */
    facets: async () => (await axios.get(`${base()}/facets`, { headers: getAuthHeaders() })).data,
};

/** No-login view of a saved filter (/v/:token). */
export const publicViewService = (token) => ({
    view: async (from, to) =>
        (await axios.get(`${api()}/api/v3/public/views/${encodeURIComponent(token)}`, { params: { from, to } })).data,
});

export default TaskViewService;
